export default __webpack_public_path__ + "static/media/caption-1-min.b5a3c1bf.jpg";